import { SEARCH_DETAILS } from '../constants';

/**
 * @function getSearchDetailsPostalCode
 * Returns the search details' postal code from local storage
 *
 * @returns {string} postalCode - The search details' postalcode retrieved from Location Search MFE's local storage
 */

const getSearchDetailsPostalCode = () => {
  try {
    const searchDetails = window.localStorage.getItem(SEARCH_DETAILS);
    const { postCode: postalCode = '' } = JSON.parse(searchDetails);
    return postalCode;
  } catch (e) {
    return '';
  }
};

export default getSearchDetailsPostalCode;
